import React from "react"
import APP_STATE from "constants/appState.js"
import { useShallow } from "zustand/react/shallow"
import { useLocation } from "react-router-dom"
import { Chatbot, useChatbot } from "@xogene/xogene-chatbot"
import useChatbotStore from "context/stores/useChatbotStore"
import useAppState from "../../context/hooks/useAppState"

import "./ChatbotWrapper.scss"

export default function ChatbotWrapper() {
  const { setOpenChatbot } = useChatbot()
  const { appState } = useAppState()
  const { setChatbotContext } = useChatbotStore(
    useShallow((state) => ({
      setChatbotContext: state.setChatbotContext,
    }))
  )

  const location = useLocation()

  React.useEffect(() => {
    if (location.pathname) {
      setChatbotContext({
        url: location.pathname,
      })
    }
  }, [location?.pathname])

  React.useEffect(() => {
    if (appState === APP_STATE.unauthenticated) {
      setOpenChatbot(false)
    }
  }, [appState])

  return (
    <div className="chatbot-wrapper">
      <Chatbot width={410} />
    </div>
  )
}
